/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Cidr } from './Cidr';
import {
    CidrFromJSON,
    CidrFromJSONTyped,
    CidrToJSON,
} from './Cidr';

/**
 * 
 * @export
 * @interface FirewallRuleSchema
 */
export interface FirewallRuleSchema {
    /**
     * 
     * @type {Array<number>}
     * @memberof FirewallRuleSchema
     */
    ports: Array<number>;
    /**
     * 
     * @type {Cidr}
     * @memberof FirewallRuleSchema
     */
    cidr: Cidr;
    /**
     * 
     * @type {string}
     * @memberof FirewallRuleSchema
     */
    direction: FirewallRuleSchemaDirectionEnum;
}


/**
 * @export
 */
export const FirewallRuleSchemaDirectionEnum = {
    Ingress: 'ingress',
    Egress: 'egress'
} as const;
export type FirewallRuleSchemaDirectionEnum = typeof FirewallRuleSchemaDirectionEnum[keyof typeof FirewallRuleSchemaDirectionEnum];


/**
 * Check if a given object implements the FirewallRuleSchema interface.
 */
export function instanceOfFirewallRuleSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ports" in value;
    isInstance = isInstance && "cidr" in value;
    isInstance = isInstance && "direction" in value;

    return isInstance;
}

export function FirewallRuleSchemaFromJSON(json: any): FirewallRuleSchema {
    return FirewallRuleSchemaFromJSONTyped(json, false);
}

export function FirewallRuleSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirewallRuleSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ports': json['ports'],
        'cidr': CidrFromJSON(json['cidr']),
        'direction': json['direction'],
    };
}

export function FirewallRuleSchemaToJSON(value?: FirewallRuleSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ports': value.ports,
        'cidr': CidrToJSON(value.cidr),
        'direction': value.direction,
    };
}

